{
  "planReady": {
    "title": "Your plan is ready",
    "body": "{{name}} — review the generated plan."
  },
  "dataIngestComplete": {
    "title": "Your files are ready",
    "body": "{{name}} — {{count}} files processed."
  },
  "completenessReady": {
    "title": "Data check complete",
    "body": "{{name}} — you're cleared to generate."
  },
  "completenessNeedsData": {
    "title": "Data check complete",
    "body": "{{name}} — some data is missing. Review what's needed."
  },
  "sectionsReady": {
    "title": "Your sections are ready",
    "body": "{{name}} — {{count}} sections generated. Ready for review."
  },
  "validationComplete": {
    "title": "Self-check complete",
    "body": "{{name}} — review the self-checked report."
  },
  "planRevisionComplete": {
    "title": "Plan updated",
    "body": "{{name}} — review the revised plan."
  },
  "failure": {
    "title": "Something needs your attention",
    "body": "{{name}} — {{stage}} couldn't finish. Open Bennie to retry."
  },
  "stageNames": {
    "planGeneration": "Plan generation",
    "dataIngest": "Data ingest",
    "completenessCheck": "Completeness check",
    "sectionGeneration": "Section generation",
    "validation": "Self-check",
    "planRevision": "Plan revision"
  },
  "extractorComplete": {
    "title": "Model extract is done",
    "body": "{{target}} — model extract is ready."
  },
  "extractorFailed": {
    "title": "Model extract couldn't finish",
    "body": "{{target}} — open Bennie to see what went wrong."
  },
  "gatekeeperComplete": {
    "title": "Gatekeeper check is done",
    "body": "{{target}} — verdict is in."
  },
  "gatekeeperFailed": {
    "title": "Gatekeeper check couldn't finish",
    "body": "{{target}} — open Bennie to see what went wrong."
  }
}
